module.exports = __webpack_public_path__ + "assets/img/theme.a8c15249.svg";